module.exports = __webpack_public_path__ + "img/app.1fcbed7c.png";